<template>
  <div class="px-page mb-8">
    <h2 class="font-semibold text-xl leading-tight">
      Customs | Sent to Print
    </h2>
  </div>

  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Order Number</th>
        <th class="hidden lg:table-cell">Customer Name</th>
        <th class="hidden lg:table-cell">Sent At</th>
      </tr>
      </thead>
      <tbody>
        <template v-if="orders.data.length" v-for="order in orders.data">
          <tr>
            <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
              <Link v-bind:href="$route('orders.show', order.order_number)">{{ order.order_number }}</Link>
              <dl class="font-normal lg:hidden">
                <dt class="sr-only">Customer</dt>
                <dd class="mt-1 truncate text-gray-700">{{ order.customer_name }}</dd>
                <dt class="sr-only sm:hidden">Sent At</dt>
                <dd class="mt-1 truncate text-gray-500 sm:hidden">{{ order.sent_at_formatted ?? 'No Data' }}</dd>
              </dl>
            </td>
            <td class="hidden text-gray-500 lg:table-cell">
              {{ order.customer_name }}
            </td>
            <td class="hidden text-gray-500 sm:table-cell">
              {{ order.sent_at_formatted ?? 'No Data' }}
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="3" class="text-center">No orders are out for print</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="pagination" />
    </div>
  </div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
import Pagination from "../../components/Pagination";

const { orders } = defineProps(['orders']);
const pagination = Object.assign({}, orders);
delete pagination.data;
</script>
